import { debounce } from './debounce';
import isMobile from './is-mobile';

let currentFormat = isMobile();
export function resizeController(){
    window.addEventListener("resize",debounce((e)=>{
        if(isMobile()==currentFormat) return;
        currentFormat = isMobile();
        location.reload();
    },500));
}